/* A single responsive department navigation, enhanced from native details. */
(() => {
  if (window.saberNavigationInitialized) return;
  window.saberNavigationInitialized = true;
  document.documentElement.classList.add("ss-js");
  const desktop = window.matchMedia("(min-width: 750px)");
  const openMenu = () => document.querySelector(".ss-departments[open]");
  const observedPanels = new WeakSet();
  const syncPanelHeight = () => {
    const menu = openMenu();
    if (!menu) return;
    const surface = menu.querySelector(".ss-mega");
    if (surface) {
      menu.style.setProperty(
        "--ss-menu-available-height",
        `${Math.max(0, Math.floor(window.innerHeight - surface.getBoundingClientRect().top - 12))}px`,
      );
    }
    const list = menu.querySelector(".ss-mega-department-list");
    const panel = list?.querySelector(
      ".ss-mega-department[open] > .ss-mega-panel",
    );
    if (!list) return;
    if (desktop.matches && panel) {
      list.style.setProperty(
        "--ss-menu-panel-height",
        `${Math.ceil(panel.getBoundingClientRect().height)}px`,
      );
      if (panelObserver && !observedPanels.has(panel)) {
        observedPanels.add(panel);
        panelObserver.observe(panel);
      }
    } else {
      list.style.removeProperty("--ss-menu-panel-height");
    }
  };
  const panelObserver =
    typeof ResizeObserver === "function"
      ? new ResizeObserver(syncPanelHeight)
      : null;
  const closeMenu = (restoreFocus = false) => {
    const menu = openMenu();
    if (!menu) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector(":scope > summary").focus();
  };
  document.addEventListener("click", (event) => {
    const menu = openMenu();
    if (event.target.closest("[data-ss-menu-close]")) {
      closeMenu(true);
      return;
    }
    if (menu && !menu.contains(event.target)) closeMenu();
  });
  document.addEventListener("focusin", (event) => {
    const menu = openMenu();
    if (menu && !menu.contains(event.target)) closeMenu();
  });
  document.addEventListener(
    "toggle",
    (event) => {
      const disclosure = event.target;
      if (disclosure.matches(".ss-departments[open]")) {
        // Select the first rendered, valid destination only on desktop.
        if (
          desktop.matches &&
          !disclosure.querySelector(".ss-mega-department[open]")
        ) {
          const first = disclosure.querySelector(".ss-mega-department");
          if (first) first.open = true;
        }
      } else if (disclosure.matches(".ss-mega-department, .ss-mega-category")) {
        if (disclosure.open) {
          const selector = disclosure.matches(".ss-mega-category")
            ? ":scope > .ss-mega-category[open]"
            : ":scope > .ss-mega-department[open]";
          disclosure.parentElement
            .querySelectorAll(selector)
            .forEach((sibling) => {
              if (sibling !== disclosure) sibling.open = false;
            });
        }
      } else return;
      requestAnimationFrame(syncPanelHeight);
    },
    true,
  );
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu(true);
      return;
    }
    const summary = event.target.closest(".ss-mega-department > summary");
    if (!summary || !desktop.matches) return;
    const department = summary.parentElement;
    const summaries = [
      ...department.parentElement.querySelectorAll(
        ":scope > .ss-mega-department > summary",
      ),
    ];
    const index = summaries.indexOf(summary);
    let next;
    if (event.key === "ArrowDown") next = (index + 1) % summaries.length;
    if (event.key === "ArrowUp")
      next = (index - 1 + summaries.length) % summaries.length;
    if (event.key === "Home") next = 0;
    if (event.key === "End") next = summaries.length - 1;
    if (next !== undefined) {
      event.preventDefault();
      summaries[next].parentElement.open = true;
      summaries[next].focus();
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      department.open = true;
      department.querySelector(".ss-mega-panel a")?.focus();
    }
  });
  window.addEventListener("resize", () =>
    requestAnimationFrame(syncPanelHeight),
  );
  desktop.addEventListener("change", () => {
    closeMenu();
    document.querySelectorAll(".ss-mega-department-list").forEach((list) => {
      list.style.removeProperty("--ss-menu-panel-height");
    });
  });
})();
